import { ValueType } from 'realgrid'
export const salseOrderfields = [
    {fieldName: 'custCd', dataType: ValueType.TEXT},
    {fieldName: 'custNm', dataType: ValueType.TEXT},
    {fieldName: 'ordDt', dataType: ValueType.TEXT},
    {fieldName: 'ordNo', dataType: ValueType.TEXT},
    {fieldName: 'ordLineNo', dataType: ValueType.TEXT},
    {fieldName: 'ordType', dataType: ValueType.TEXT},
    {fieldName: 'deliDt', dataType: ValueType.TEXT},
    {fieldName: 'itemCd', dataType: ValueType.TEXT},
    {fieldName: 'itemNm', dataType: ValueType.TEXT},
    {fieldName: 'qty', dataType: ValueType.NUMBER},
    {fieldName: 'baseUnit', dataType: ValueType.TEXT},
    {fieldName: 'price', dataType: ValueType.NUMBER},
    {fieldName: 'vatTotal', dataType: ValueType.NUMBER},
    {fieldName: 'vat', dataType: ValueType.NUMBER},
    {fieldName: 'priceVat', dataType: ValueType.NUMBER}
  ]
  export const salseOrderColumns = [
    {
      name: 'custCd',
      fieldName: 'custCd',
      type: 'data',
      width: '100',
      styleName: "rg-align-center",
      header: {
          text: '거래처코드',
          showTooltip: false
      }
    },
    {
        name: 'custNm',
        fieldName: 'custNm',
        type: 'data',
        width: '100',
        styleName: "rg-align-left",
        header: {
            text: '거래처명',
            showTooltip: false
        }
    },
    {
      name: 'ordDt',
      fieldName: 'ordDt',
      type: 'data',
      width: '100',
      styleName: "rg-align-left",
      header: '주문일자',
    },
    {
      name: 'ordNo',
      fieldName: 'ordNo',
      type: 'data',
      width: '80',
      styleName: "rg-align-left",
      header: '주문번호',
    },
    {
      name: 'ordLineNo',
      fieldName: 'ordLineNo',
      type: 'data',
      width: '100',
      styleName: "rg-align-left",
      header: '주문순번',
      visible: false
    },
    {
      name: 'ordType',
      fieldName: 'ordType',
      type: 'data',
      width: '100',
      styleName: "rg-align-left",
      header: '주문유형',
      visible: false
    },
    {
      name: 'deliDt',
      fieldName: 'deliDt',
      type: 'data',
      width: '100',
      styleName: "rg-align-left",
      header: '배송일자',
    },
    {
      name: 'itemCd',
      fieldName: 'itemCd',
      type: 'data',
      width: '100',
      styleName: "rg-align-center",
      header: { 
          text: '제품코드',
          showTooltip: false
      }
    },
    {
        name: 'itemNm',
        fieldName: 'itemNm',
        type: 'data',
        width: '150',
        styleName: "rg-align-left",
        header: {
            text: '제품명',
            showTooltip: false
        }
    },
    {
      name: 'qty',
      fieldName: 'qty',
      type: 'data',
      width: '80',
      numberFormat: "#,##0.#",
      styleName: "rg-align-right",
      header: {
          text: '수량',
          showTooltip: false
      },
      footer: {
          text: "총합계",
          numberFormat: "#,##0.#",
          expression: "sum",
      }
    },
    {
      name: 'baseUnit',
      fieldName: 'baseUnit',
      type: 'data',
      width: '50',
      styleName: "rg-align-center",
      header: {
          text: '단위',
          showTooltip: false
      },
      visible: false
    },
    {
      name: 'vat',
      fieldName: 'vat',
      type: 'data',
      width: '100',
      numberFormat: "#,##0.#",
      styleName: "rg-align-right",
      header: {
          text: '단가\n(부가세 미포함)',
          styleName: "multi-line-css",
          showTooltip: false
      }
    },
    {
      name: 'vatTotal',
      fieldName: 'vatTotal',
      type: 'data',
      width: '100',
      numberFormat: "#,##0.#",
      styleName: "rg-align-right",
      header: {
          text: '총액\n(부가세 미포함)',
          styleName: "multi-line-css",
          showTooltip: false
      },
      footer: {
          text: "금액 총합계",
          numberFormat: "#,##0.#",
          expression: "sum",
      }
    },
    {
      name: 'price',
      fieldName: 'price',
      type: 'data',
      width: '100',
      numberFormat: "#,##0.#",
      styleName: "rg-align-right",
      header: {
          text: '단가\n(부가세 포함)',
          styleName: "multi-line-css",
          showTooltip: false
      }
    },
    {
      name: 'priceVat',
      fieldName: 'priceVat',
      type: 'data',
      width: '100',
      numberFormat: "#,##0.#",
      styleName: "rg-align-right",
      header: {
          text: '총액\n(부가세 포함)',
          styleName: "multi-line-css",
          showTooltip: false
      },
      footer: {
          text: "부가세합계",
          numberFormat: "#,##0.#",
          expression: "sum",
      }
    }
  ]